import dayjs from 'dayjs';
import { isDailyTimeRateSystem } from 'src/helpers/modular/timeRateSystemsUtil';
import Utils from 'src/utils';
class PersonContracts {
    contracts = [];
    constructor(contracts) {
        this.contracts = contracts;
    }
    onDate(date) {
        const requiredDate = dayjs(date);
        return this.contracts.find((contract) => {
            const from = dayjs(contract.Active.Start);
            const to = contract.Active?.End ? dayjs(contract.Active.End) : null;
            return requiredDate.isSameOrAfter(from) && (!to || requiredDate.isBefore(to));
        });
    }
    isDailyOnDate(date) {
        const contract = this.onDate(date);
        const timeRateSystemName = Utils.strings.decapitalize(contract?.TimeRateSystem?.Name || '');
        return isDailyTimeRateSystem(timeRateSystemName);
    }
}
export default PersonContracts;
